import React from "react";
import {
  LightningIcon,
  SealCheckIcon,
  TrendUpIcon,
  SparkleIcon,
} from "@phosphor-icons/react";

const TIER_CONFIG = {
  new: {
    label: "NEW",
    cls: "bg-zinc-100 text-zinc-700 border border-zinc-200",
    Icon: SparkleIcon,
    tone: "text-zinc-500",
  },
  rising: {
    label: "RISING",
    cls: "bg-sky-50 text-sky-700 border border-sky-200",
    Icon: TrendUpIcon,
    tone: "text-sky-600",
  },
  trusted: {
    label: "TRUSTED",
    cls: "bg-emerald-50 text-emerald-700 border border-emerald-200",
    Icon: SealCheckIcon,
    tone: "text-emerald-600",
  },
  instant: {
    label: "INSTANT",
    cls: "bg-amber-100 text-amber-800 border border-amber-300",
    Icon: LightningIcon,
    tone: "text-amber-600",
  },
};

export default function TrustTierBadge({ tier, size = "sm", withIcon = true, className = "" }) {
  if (!tier || !tier.id) return null;
  const cfg = TIER_CONFIG[tier.id] || TIER_CONFIG.new;
  const sizeCls =
    size === "xs"
      ? "px-1.5 py-0.5 text-[9px] gap-0.5"
      : size === "lg"
      ? "px-2.5 py-1 text-[11px] gap-1.5"
      : "px-2 py-0.5 text-[10px] gap-1";
  const iconSize = size === "lg" ? 12 : size === "xs" ? 9 : 10;
  const Icon = cfg.Icon;
  return (
    <span
      className={`inline-flex items-center font-bold tracking-widest uppercase ${cfg.cls} ${sizeCls} ${className}`}
      title={
        tier.sales_count !== undefined
          ? `${cfg.label} seller · ${tier.sales_count} lifetime sales`
          : cfg.label
      }
      data-testid={`trust-tier-${tier.id}`}
    >
      {withIcon && Icon && (
        <Icon size={iconSize} weight={tier.id === "instant" ? "fill" : "regular"} className={cfg.tone} />
      )}
      {cfg.label}
    </span>
  );
}
